import { Icon as ReactIcon } from "@iconify/react/dist/iconify.js";
import { Box, IconButton, Tooltip, Typography, useTheme } from "@mui/material";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { FiX } from "react-icons/fi";

const FileUpload = ({ Icon, label, placeholder, onChange, disabled = false, preview, deletePreview = () => {}, accept, file }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const ref = useRef(null);
  const download = (file, filename) => {
    if (file) {
      const url = window.URL.createObjectURL(file);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      link.click();
    }
  };
  const clear = () => {
    const temp = Math.random().toString(36);
    if (ref.current) {
      ref.current.value = "";
      ref.current.type = "text";
      ref.current.type = "file";
    }
    deletePreview();
  };
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, width: 1, flex: 1 }}>
      {label && (
        <Box sx={{ display: "flex", gap: 0.75 }}>
          {Icon && <Icon size={16} style={{ color: theme.palette.text.navigation, marginTop: "auto", marginBottom: "auto" }} />}
          <Typography variant="Textbox Label">{t(label)}</Typography>
          {preview && (
            <Tooltip title={"Delete"}>
              <IconButton
                onClick={() => {
                  clear();
                }}
                sx={{
                  padding: 0,
                  color: isDark ? "#94a3b8" : "#999999",
                  "&:hover": { color: isDark ? "#f1f5f9" : "black", backgroundColor: "transparent" },
                }}>
                <FiX size={16} />
              </IconButton>
            </Tooltip>
          )}
          {preview && (
            <Tooltip title={"Download"}>
              <IconButton
                onClick={() => {
                  download(file, preview);
                }}
                sx={{
                  padding: 0,
                  color: isDark ? "#94a3b8" : "#999999",
                  "&:hover": { color: isDark ? "#f1f5f9" : "black", backgroundColor: "transparent" },
                }}>
                <ReactIcon icon="fe:download" style={{ color: "inherit", height: "15px" }} />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      )}
      <Box
        sx={{
          display: "flex",
          backgroundColor: isDark ? "#27272a" : "#f9fafb",
          flexGrow: 1,
          flexDirection: "column",
          borderWidth: 2,
          borderRadius: 1,
          borderStyle: "dashed",
          borderColor: theme.palette.border.main,
          "&:hover": {
            borderColor: theme.palette.text.navigation,
          },
        }}
        style={{ flex: 1 }}
        onClick={disabled ? undefined : () => ref.current.click()}>
        <input type="file" accept={accept} ref={ref} onChange={onChange} disabled={disabled} style={{ display: "none" }} />
        <Box sx={{ marginY: "auto" }}>
          <Typography
            sx={{
              color: isDark ? "#94a3b8" : "#6b7280",
              fontSize: 14,
              fontFamily: "Poppins",
              textAlign: "center",
            }}>
            {preview ? preview : t(placeholder)}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
export default FileUpload;
